import {api} from "./api";
import {MODERATOR_USER} from "../mock/URLs";
import {GetUserResponse, User} from "../types/user";

type GetUsers = {
  params?: {
    page?: number
    search?: string
    top?: boolean
  }
}

export const getUsers = async ({params}: GetUsers) => {
  try {
    const {data} = await api.get<GetUserResponse>(MODERATOR_USER, {
      params
    })
    return data
  } catch (e) {
    throw e
  }
}

export const getUserById = async (id: number) => {
  try {
    const {data} = await api.get<{ data: User }>(`${MODERATOR_USER}${id}/`)
    return data.data
  } catch (e) {
    throw e
  }
}

export const updateUser = async (id, values) => {
  try {
    const {data} = await api.patch<GetUserResponse>(`${MODERATOR_USER}${id}/`, values)
    return data.data
  } catch (e) {
    throw e
  }
}